export const RECEIVE_COMMUNITY_COIN_BALANCE = "RECEIVE_COMMUNITY_COIN_BALANCE";

export const receiveCommunityCoinBalances = (payload) => ({
  payload,
  type: RECEIVE_COMMUNITY_COIN_BALANCE,
});
